module.exports = __webpack_public_path__ + "../../../../content/dam/gfps/com/website-tools/carbon-calculator/fonts/GlyphaLTW05-65Bold.woff2";